// todo: add the others modules
const VALIDATION_WORKFLOW_MODULE = 'VALIDATION_WORKFLOW';
const MODULE_EXTERNAL_STORAGE = 'EXTERNAL_STORAGE';

export { VALIDATION_WORKFLOW_MODULE, MODULE_EXTERNAL_STORAGE };
